import { useQuery } from '@apollo/client';
import { GetAccountOptionsDocument } from '../../../graphql/query/providers/GetAccountOptions.generated';

export const useAccountOptionsFetch = () => {
  const { loading: accountOptionsLoading, error, data: { account = [] } = {} } = useQuery(GetAccountOptionsDocument);

  return { account, accountOptionsLoading, error };
};
